import ObjectPool from "./ObjectPool";

const pool: Array<Array<unknown>> = [];

export default class ArrayPool {
    /**
     * Get an object from the pool
     */
    public static Get<T>(): Array<T> {
        if(pool.length) {
            return pool.pop() as Array<T>;
        }

        return [];
    }

    /**
     * Release an object back into the pool
     */
    public static Release(arr: Array<unknown>): void {
        // Ensure this is an array
        if(!Array.isArray(arr)) {
            // Send it to the object pool
            ObjectPool.Release(arr);

            return;
        }

        // Reset the array
        arr.length = 0;

        // Add the array back to the pool
        pool.push(arr);
    }

    public static CheckPool(): Array<Array<unknown>> {
        return pool;
    }
}
